import { useEffect, useState } from 'react';
import api from '@/shared/api/client';

/**
 * La liste des agrégateurs, LUE EN BASE et non écrite dans le code.
 *
 * POURQUOI CE HOOK EXISTE — revue du 31/08/2026
 *
 * Boubacar crée l'agrégateur TILT depuis l'écran Agrégateurs, puis ouvre un client
 * pour le lui attribuer : la liste ne propose que Survoltage, Symphonics et « Autre ».
 *
 * Ces trois valeurs étaient écrites en dur, à sept endroits au moins — ClientsPage
 * (deux fois), ClientDetailPage, MonitoringPage, bulkActions, et jusque dans
 * `shared/api/bridge.js`. Au départ il n'y avait que deux agrégateurs ; l'écran de
 * création libre est arrivé après, sans que les listes suivent. Personne ne pouvait le
 * voir : chaque liste, prise isolément, avait l'air complète.
 *
 * ⚠️ La source est `/aggregateurs/noms`, PAS `/aggregateurs`. Cette dernière est gardée
 * par `tarifs:read`, que le gestionnaire n'a plus depuis le 30/08 — et c'est justement
 * lui qui attribue un agrégateur à un client tous les jours. La brancher ici aurait
 * rendu les listes vides pour le rôle qui s'en sert le plus.
 *
 * Le repli en cas d'échec réseau est la liste VIDE, jamais une liste écrite à la main :
 * un repli en dur reproduirait exactement le défaut que ce hook corrige, et il ne se
 * verrait que le jour où quelqu'un chercherait son agrégateur absent.
 */
export default function useAgregateurs() {
  const [agregateurs, setAgregateurs] = useState([]);
  const [charge, setCharge] = useState(false);

  useEffect(() => {
    let vivant = true;
    api.get('/aggregateurs/noms')
      .then(({ data }) => { if (vivant) setAgregateurs(data?.aggregateurs || []); })
      .catch(() => { if (vivant) setAgregateurs([]); })
      .finally(() => { if (vivant) setCharge(true); });
    return () => { vivant = false; };
  }, []);

  return { agregateurs, charge };
}

/**
 * La valeur qui dit « ce client n'a pas encore d'agrégateur ».
 *
 * Ce n'est PAS un agrégateur qui s'appellerait « Non attribué » : en base le champ est
 * vide. Le libellé ne vit que dans l'interface, et la valeur envoyée au serveur est la
 * chaîne vide.
 */
export const NON_ATTRIBUE = '';
export const LIBELLE_NON_ATTRIBUE = 'Non attribué';
